import { IObservableArray, makeAutoObservable } from 'mobx';
import { ToastTypeEnum } from '../Components/Toast/ToastTypeEnum';

export class Notification {
  message: string;

  type: ToastTypeEnum | undefined;

  onClose?: () => void;

  actions?: Array<{ text: string; onClick: () => void }>;

  duration?: number;

  readonly timeStamp?: number = Date.now();

  constructor(params: Partial<Notification> = {}) {
    Object.assign(this, params);
  }
}

class NotificationStore {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private readonly _notifications: IObservableArray<Notification> = [] as any;

  constructor() {
    makeAutoObservable(this);
  }

  get notifications(): IObservableArray<Notification> {
    return this._notifications;
  }

  push(notification: Notification) {
    const notificationLocal = new Notification({ ...notification });
    this._notifications.push(notificationLocal);
  }

  remove(notification: Notification) {
    return this._notifications.remove(notification);
  }

  clear() {
    return this._notifications.clear();
  }
}

export default NotificationStore;
